import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { BillingCode, BillingCodeType } from "../../interfaces/screens/billing";
import { ColumnType } from "../utils/enums";
import CurrencyDisplay from "../../components/CurrencyDisplay";
import { Edit, Trash2 } from "lucide-react";

interface BillingCodesTableColumnsProps {
  onEdit: (code: BillingCode) => void;
  onDelete: (code: BillingCode) => void;
}

const getBadgeClass = (type: BillingCodeType) => {
  switch (type) {
    case "cpt":
      return "bg-blue-100 text-blue-800";
    case "icd":
      return "bg-green-100 text-green-800";
    case "ndc":
      return "bg-purple-100 text-purple-800";
    case "service":
      return "bg-yellow-100 text-yellow-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getBillingCodesTableColumns = ({
  onEdit,
  onDelete,
}: BillingCodesTableColumnsProps): TableColumnsItem[] => {
  return [
    {
      key: "code",
      name: "Code",
      type: ColumnType.TEXT,
    },
    {
      key: "description",
      name: "Description",
      type: ColumnType.TEXT,
      customCellClass: "w-1/2",
    },
    {
      key: "type",
      name: "Type",
      type: ColumnType.CUSTOM,
      customValue: (row: BillingCode) => (
        <span
          className={`px-2 py-1 text-xs font-medium rounded-full ${getBadgeClass(
            row.type,
          )}`}
        >
          {row.type.toUpperCase()}
        </span>
      ),
    },
    {
      key: "unit_price",
      name: "Unit Price",
      type: ColumnType.CUSTOM,
      customValue: (row: BillingCode) => {
        if (row.unit_price === null || row.unit_price === undefined) {
          return <span className="text-gray-400">N/A</span>;
        }
        return <CurrencyDisplay amount={row.unit_price} currency="USD" />;
      },
    },
    {
      key: "actions",
      name: " ",
      type: ColumnType.CUSTOM,
      customValue: (row: BillingCode) => (
        <div className="flex items-center justify-end space-x-2">
          <button
            onClick={() => onEdit(row)}
            className="p-2 text-gray-500 rounded-full hover:bg-gray-100 hover:text-blue-600"
          >
            <Edit size={18} />
          </button>
          <button
            onClick={() => onDelete(row)}
            className="p-2 text-gray-500 rounded-full hover:bg-gray-100 hover:text-red-600"
          >
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];
}; 